import { createHOC } from 'vue-hoc';

import SignupForm from './SignupForm';
import auth from '../../../../lib/common/providers/auth';
import userManagement from '../../../../lib/common/providers/userManagement';

const options = {
  name: 'SignupFormContainer',
  data() {
    return {
      state: {
        loading: false,
        error: null,
        invited: false,
        pending: false,
      },
    };
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
    invited() {
      return this.state.invited;
    },
    pending() {
      return this.state.pending;
    },
  },
  listeners: {
    async signup(user, accountType) {
      const { query } = this.$route;
      this.state.error = null;
      this.state.pending = false;
      this.state.loading = true;
      try {
        // If it's an invitation, the user is already signed up
        // simply finish the invitation flow
        if (query.email && query.token) {
          await userManagement.post('/invitations/finish', user, {
            headers: {
              Authorization: `Bearer ${query.token}`
            }
          });
          await auth.login(user);
        } else {
          // See if user has a pending invite
          const result = await userManagement.post('invites/pending', { email: user.email });
          if (result.data && result.data.pending) {
            this.state.pending = true;
          } else {
            // Invite the user to the public org
            await userManagement.post('/invitations/invite-unaffiliated', {
              email: user.email,
              accountType
            });
            this.state.invited = true;
          }
        }
      } catch (error) {
        if (error.code === 'invalid_password') {
          this.state.error = { ...error, message: `Password is too weak\n${error.policy}` };
        } else {
          this.state.error = { ...error, message: error.message || error.description };
        }
      } finally {
        this.state.loading = false;
      }
    },
  },
};

const SignupFormContainer = createHOC(SignupForm, options, renderWith);
export default SignupFormContainer;
